import React from 'react'
import PropTypes from 'prop-types'
import { compose, withState } from 'recompose'
import FormLabel from 'components/labels/FormLabel'
import FormLanguage from 'components/forms/FormLanguage'
import FormTextAreaWithLanguage from 'components/forms/FormTextAreaWithLanguage'
import FormTextInput from 'components/forms/FormTextInput'
import FormLocation from 'components/forms/FormLocation'
import FormSelect from 'components/forms/bases/FormSelect'
import FormImage from 'components/forms/image/FormImage'
import Grid from 'components/grids/Grid'
import CustomFlatButton from 'components/Button/CustomFlatButton'
import styled from 'styled-components'
import withStoreLocator from 'store/storeLocator/withStoreLocator'
import { withStoreLocatorPreferences } from 'store/preferences/withPreferences'
import TypeEditor from 'components/forms/storeLocator/TypeEditor'
import ItemUpdater from 'components/wrappers/ItemUpdater'
import CircleAddButton from 'components/Button/CircleAddButton'
import { removeItemArrayByIndex, updateItemArrayByIndex, addItemToArray } from 'helpers/arrayHelpers'
import withStore from '../hocs/withStore'

const EnhancedTypeEditor = ItemUpdater.Enhance(TypeEditor)

const Button = styled(CustomFlatButton)`

`
const FormContainer = styled.div`
  width: 100%;
  margin-left: 10px;
  p {
    padding-bottom: 10px;
    margin-left: -10px;
  }
`
const StoreForm = (props) => {
  const {
    storeData: {
      name = {},
      image = {},
      isActive,
      address = {},
      phone,
      location = {},
      tags,
      type,
      mapUrl,
      openHours = [],
    },
    storeLocatorPreferences: {
      showTypes = false,
      showMapUrl = false,
    } = {},
    storeLocator: {
      types: {
        collections = [],
      } = {},
    } = {},
    storeData,
    setName,
    setImage,
    setIsActive,
    setAddress,
    setPhone,
    setLocation,
    setMapUrl,
    setType,
    setOpenHours,
    setTags,
    brandOptions,
    typeOptions,
    onSave,
    onCancel,
    meta: {
      brand: enableBrand,
      type: enableType,
      banner: enableBanner,
    },
    newItem,
    setNewItem,
    actionsDisabled,
    setActionsDisabled,
  } = props
  const columnWidth = 8
  const handleAddButtonClick = () => setNewItem({ en: '', th: ''})
  const handleRemoveOpenHour = (index) => (
    setOpenHours(removeItemArrayByIndex(openHours, index))
  )
  const handleSaveOpenHour = (val, index) => (
    setOpenHours(updateItemArrayByIndex(openHours, index, () => val))
  )
  return (
    <Grid>
      <Grid.Row>
        <Grid.Column width={columnWidth}>
          <FormLanguage
            label="Name"
            value={name}
            onChange={setName}
          />
        </Grid.Column>
      </Grid.Row>
      {showMapUrl && (
        <Grid.Row>
          <Grid.Column>
            <FormLabel>Map (image)</FormLabel>
            <div style={{ display: 'flex' }}>
              <FormImage.Image src={mapUrl} centered={false} />
              <FormImage.Upload onChange={setMapUrl} />
            </div>
          </Grid.Column>
        </Grid.Row>
      )}
      <Grid.Row>
        <Grid.Column width={columnWidth}>
          <FormTextAreaWithLanguage
            label="Address"
            value={address}
            rows={1}
            onChange={setAddress}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={columnWidth}>
          <FormContainer>
            <FormTextInput
              label="Phone"
              value={phone}
              onChange={setPhone}
            />
          </FormContainer>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={columnWidth}>
          <FormContainer>
            <FormLocation
              label="Location"
              value={location}
              onChange={setLocation}
            />
          </FormContainer>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={columnWidth}>
          <FormLabel>Office Hours</FormLabel>
          <FormContainer>
            {openHours.map((hour, i) => (
              <EnhancedTypeEditor
                key={i}
                noLabel
                value={hour}
                onDelete={() => handleRemoveOpenHour(i)}
                onSave={(val) => {
                  handleSaveOpenHour(val, i)
                  return Promise.resolve()
                }}
                onEdit={() => setActionsDisabled(true)}
                onDiscard={() => setActionsDisabled(false)}
              />
            ))}
            {newItem && (
              <ItemUpdater
                showActions
                onSave={() => {
                  setOpenHours(addItemToArray(openHours, newItem))
                  setActionsDisabled(false)
                  setNewItem(null)
                }}
                onDiscard={() => {
                  setNewItem(null)
                }}
              >
                <TypeEditor
                  noLabel
                  isEditing
                  value={newItem}
                  onChange={setNewItem}
                />
              </ItemUpdater>
            )}
            {(!newItem && !actionsDisabled) && (
              <CircleAddButton
                onClick={handleAddButtonClick}
              />
            )}
          </FormContainer>
        </Grid.Column>
      </Grid.Row>
      {showTypes && (
        <Grid.Row>
          <Grid.Column width={columnWidth}>
            <FormSelect
              placeholder={'Store Type'}
              options={collections.map(({ id, name: { en, th } }) => ({ label: `${en}/${th}`, value: id }))}
              value={type}
              onChange={setType}
            />
          </Grid.Column>
        </Grid.Row>
      )}
      {
        enableBrand && (
          <Grid.Row>
            <Grid.Column width={columnWidth}>
              {/* brand */}
            </Grid.Column>
          </Grid.Row>
        )
      }
      {
        enableType && (
          <Grid.Row>
            <Grid.Column width={columnWidth}>
              {/* type */}
            </Grid.Column>
          </Grid.Row>
        )
      }
      <Grid.Row>
        <Grid.Column>
          <Button
            style={{ marginRight: 10 }}
            onClick={() => onCancel()}
          >
            Cancel
          </Button>
          <Button
            secondary
            onClick={() => onSave(storeData)}
          >
            Save
          </Button>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}

StoreForm.propTypes = {
  storeData: PropTypes.object,
  // setStore: PropTypes.func,
  setName: PropTypes.func,
  setImage: PropTypes.func,
  setIsActive: PropTypes.func,
  setAddress: PropTypes.func,
  setPhone: PropTypes.func,
  setLocation: PropTypes.func,
  setTags: PropTypes.func,
  brandOptions: PropTypes.array,
  typeOptions: PropTypes.array,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  meta: PropTypes.shape({
    banner: PropTypes.bool,
    type: PropTypes.bool,
    brand: PropTypes.bool,
  }),
}

StoreForm.defaultProps = {
  storeData: {},
  // setStore: () => {},
  setName: () => {},
  setImage: () => {},
  setIsActive: () => {},
  setAddress: () => {},
  setPhone: () => {},
  setLocation: () => {},
  setTags: () => {},
  brandOptions: [],
  typeOptions: [],
  onSave: () => {},
  onCancel: () => {},
  meta: {
    banner: false,
    type: false,
    brand: false,
  },
}

export default compose(
  withStoreLocator(),
  withStoreLocatorPreferences(),
  withStore(),
  withState('actionsDisabled', 'setActionsDisabled', false),
  withState('newItem', 'setNewItem', null),
)(StoreForm)



// WEBPACK FOOTER //
// ./src/pages/StoreLocator/stores/StoreForm.js